import { Mate, MateHouseSessionMessage } from "@/types/entity";
import { computed } from "vue";
import { useHouseSession } from "../store/houseSession";
import { useMate } from "@/stores/mate";
export const useHouseMessageList = ({ mateId }: { mateId?: number }) => {
  const houseSessionStore = useHouseSession();
  const mateStore = useMate();

  const messageList = computed<MateHouseSessionMessage[]>(() => {
    const messageList: MateHouseSessionMessage[] = mateId
      ? houseSessionStore.mateId2MessageList[mateId] ?? []
      : houseSessionStore.fullMessageList;

    messageList.forEach((v) => {
      if (v.mateId && !v.mate) {
        v.mate = mateStore.getMyMateById(v.mateId) || ({} as Mate);
      }
    });

    return messageList;
  });

  const scrollLoad = async () => {
    const { hasMore } = mateId
      ? await houseSessionStore.getOlderMateMessageList(mateId)
      : await houseSessionStore.fetchOlderFullList();
    return hasMore;
  };

  const pullLoad = async () => {
    return mateId
      ? await houseSessionStore.getNewerMateMessageList(mateId)
      : await houseSessionStore.fetchNewerFullList();
  };

  return {
    messageList,
    scrollLoad,
    pullLoad,
  };
};
